
import React, { useEffect, useState, useRef } from 'react';
import './dialogbuy.css';
import axios from 'axios';
import { toast } from 'react-hot-toast';

function DialogBuy({ isOpen, onClose, cartItems, totalPrice }) {
  
  
  
  const [apiUrl, setApiUrl] = useState('');

  useEffect(() => {
    fetch('/templates/api.txt')
      .then((res) => res.text())
      .then((data) => {
        setApiUrl(data.trim());
      })
      .catch((err) => console.error('Ошибка при загрузке API URL:', err));
  }, []);

  
  
  
  const [info, setInfo] = useState({
    minPrice: 900,
    sdekPrice: 319,
    ruPrice: 219,
    corPrice: 419,
    phone: '',
    telegram: '',
    whatsapp: ''
  });

  
  
  
  const [orderSuccess, setOrderSuccess] = useState(false);
  const [orderId, setOrderId] = useState(null);

  
  
  
  const [cities, setCities] = useState([]);
  const [cityFilter, setCityFilter] = useState('');
  const [showCities, setShowCities] = useState(false);
  const cityInputRef = useRef(null);
  const [chosenCity, setChosenCity] = useState('');

  
  
  
  const [address, setAddress] = useState('');
  const [name, setName] = useState('');
  const [surname, setSurname] = useState('');
  const [phone, setPhone] = useState('');

  
  
  
  const [shippingType, setShippingType] = useState('cdek');
  const [shippingPrice, setShippingPrice] = useState(319);

  
  
  
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('no-scroll');
      fetchInfo();
    } else {
      document.body.classList.remove('no-scroll');
      setOrderSuccess(false);
      setOrderId(null);
    }
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [isOpen]);

  
  const fetchInfo = async () => {
    if (!apiUrl) return;
    try {
      const response = await axios.get(`${apiUrl}api/info`);
      setInfo(response.data);

      
      if (shippingType === 'cdek') {
        setShippingPrice(response.data.sdekPrice);
      } else if (shippingType === 'courier') {
        setShippingPrice(response.data.corPrice);
      } else if (shippingType === 'russianpost') {
        setShippingPrice(response.data.ruPrice);
      }
    } catch (error) {
      console.error('Ошибка при загрузке /api/info:', error);
    }
  };

  
  
  
  useEffect(() => {
    const fetchCities = async () => {
      try {
        const response = await fetch('https://api.hh.ru/areas');
        const data = await response.json();
        const russia = data.find((country) => country.id === '113');
        if (!russia) return;

        function getAllCities(areas) {
          let result = [];
          for (const area of areas) {
            if (area.areas && area.areas.length > 0) {
              result = result.concat(getAllCities(area.areas));
            } else if (area.name) {
              result.push(area.name);
            }
          }
          return result;
        }

        const allCities = getAllCities(russia.areas);
        allCities.sort();
        setCities(allCities);
      } catch (e) {
        console.error('Ошибка при загрузке городов:', e);
        toast.error('Не удалось загрузить список городов. Попробуйте позже.');
      }
    };

    if (isOpen && !orderSuccess) {
      fetchCities();
    }
  }, [isOpen, orderSuccess]);

  
  
  
  useEffect(() => {
    if (isOpen) {
      setCityFilter('');
      setChosenCity('');
      setAddress('');
      setName('');
      setSurname('');
      setPhone('');
      setShippingType('cdek');
    }
  }, [isOpen]);

  
  
  
  const filteredCities = cities.filter((cityName) =>
    cityName.toLowerCase().startsWith(cityFilter.toLowerCase())
  );

  const handleFocus = () => setShowCities(true);
  const handleBlur = () => {
    setTimeout(() => {
      if (document.activeElement !== cityInputRef.current) {
        setShowCities(false);
      }
    }, 200);
  };

  const handleCitySelect = (cityName) => {
    setCityFilter(cityName);
    setChosenCity(cityName);
    setShowCities(false);
  };

  
  
  
  const handlePhoneChange = (e) => {
    let digits = e.target.value.replace(/\D/g, '');
    if (!digits.startsWith('7')) {
      digits = '7' + digits;
    }
    if (digits.length > 11) {
      digits = digits.slice(0, 11);
    }

    let formatted = '+7';
    if (digits.length > 1) {
      formatted += ' (' + digits.slice(1, 4);
    }
    if (digits.length >= 4) {
      formatted += ') ' + digits.slice(4, 7);
    }
    if (digits.length >= 7) {
      formatted += ' ' + digits.slice(7, 9);
    }
    if (digits.length >= 9) {
      formatted += ' ' + digits.slice(9, 11);
    }
    setPhone(formatted);
  };

  
  
  
  const handleShippingChange = (type) => {
    setShippingType(type);
    if (type === 'cdek') {
      setShippingPrice(info.sdekPrice);
    } else if (type === 'courier') {
      setShippingPrice(info.corPrice);
    } else if (type === 'russianpost') {
      setShippingPrice(info.ruPrice);
    }
  };

  
  
  
  const handleClose = () => {
    onClose();
  };

  
  
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!chosenCity) {
      toast.error('Пожалуйста, выберите город из списка.');
      return;
    }

    const card = JSON.stringify(cartItems, null, 2);
    const orderData = {
      city: chosenCity,
      address,
      name,
      surname,
      phone,
      totalPrice,
      shippingPrice,
      shippingType,
      cartItems,
      card
    };

    try {
      if (!apiUrl) {
        toast.error('API URL не загружен.');
        return;
      }
      
      const response = await axios.post(`${apiUrl}api/order`, orderData);
      
      setOrderSuccess(true);
      setOrderId(response.data.order_id);
    } catch (error) {
      console.error('Ошибка при оформлении заказа:', error);
      toast.error('Произошла ошибка при оформлении заказа. Попробуйте позже.');
    }
  };

  
  if (!isOpen) {
    return null;
  }

  
  const totalWithDelivery = totalPrice + shippingPrice;

  
  
  
  if (orderSuccess) {
    const handleCopyOrderId = () => {
      if (orderId) {
        navigator.clipboard.writeText(String(orderId));
        toast.success('Номер заказа скопирован!');
      }
    };

    return (
      <div className="dialogbuy-overlay">
        <div className="dialogbuy-content" style={{ maxHeight: '320px' }}>
          <button className="dialogbuy-close" onClick={handleClose}>
            &times;
          </button>
          <h2 style={{ textAlign: 'center', marginTop: '30px', lineHeight: '1.6' }}>
            Заказ успешно оформлен!{' '}
            {orderId && (
              <span className="copyable-order-id" onClick={handleCopyOrderId}>
                #{orderId}
              </span>
            )}
          </h2>
          <p style={{ textAlign: 'center', marginTop: '5px', fontSize: '15px', lineHeight: '1.4' }}>
          Пожалуйста, сообщите номер вашего заказа менеджеру, чтобы мы могли найти и отправить ваши товары. Либо можете написать менеджеру в чат поддержки в правом нижнем углу сайта.
          </p>
          <div className="success-buttons">
            <a
              href={`https://wa.me/${info.whatsapp || ''}`}
              target="_blank"
              rel="noopener noreferrer"
              className="success-button"
            >
              Перейти в WhatsApp
            </a>
            <a
              href={`https://t.me/${info.telegram || ''}`}
              target="_blank"
              rel="noopener noreferrer"
              className="success-button"
            >
              Перейти в Telegram
            </a>
          </div>
        </div>
      </div>
    );
  }

  
  
  
  return (
    <div className="dialogbuy-overlay">
      <div className="dialogbuy-content">
        <button className="dialogbuy-close" onClick={handleClose}>
          &times;
        </button>

        <h2 className="dialogbuy-title">Оформление заказа</h2>

        <form onSubmit={handleSubmit} className="dialogbuy-form">
          {/* Город */}
          <div className="dialogbuy-field">
            <label>Город:</label>
            <input
              type="text"
              className="dialogbuy-city-input"
              placeholder="Начните вводить название города"
              onFocus={handleFocus}
              onBlur={handleBlur}
              onChange={(e) => {
                setCityFilter(e.target.value);
                setChosenCity('');
              }}
              ref={cityInputRef}
              value={cityFilter}
              required
            />
            {showCities && filteredCities.length > 0 && (
              <div className="dialogbuy-cities-dropdown" tabIndex="0">
                {filteredCities.map((cityName, idx) => (
                  <button
                    type="button"
                    key={idx}
                    className="dialogbuy-city-item"
                    onMouseDown={() => handleCitySelect(cityName)}
                  >
                    {cityName}
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* Адрес */}
          <div className="dialogbuy-field">
            <label>Адрес:</label>
            <input
              type="text"
              maxLength={150}
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              required
            />
          </div>

          {/* Имя */}
          <div className="dialogbuy-field">
            <label>Имя:</label>
            <input
              type="text"
              maxLength={20}
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          {/* Фамилия */}
          <div className="dialogbuy-field">
            <label>Фамилия:</label>
            <input
              type="text"
              maxLength={20}
              value={surname}
              onChange={(e) => setSurname(e.target.value)}
              required
            />
          </div>

          {/* Телефон */}
          <div className="dialogbuy-field">
            <label>Телефон:</label>
            <input
              type="text"
              value={phone}
              onChange={handlePhoneChange}
              placeholder="+7 (___) ___ __ __"
              required
            />
          </div>

          {/* Тип доставки */}
          <div className="dialogbuy-field">
            <label>Тип доставки:</label>
            <div className="dialogbuy-shipping-options">
              <label className="dialogbuy-shipping-label">
                <input
                  type="radio"
                  name="shipping"
                  value="cdek"
                  checked={shippingType === 'cdek'}
                  onChange={() => handleShippingChange('cdek')}
                />
                <span className="dialogbuy-shipping-text">
                  CDEK ({info.sdekPrice}₽)
                </span>
              </label>
              <label className="dialogbuy-shipping-label">
                <input
                  type="radio"
                  name="shipping"
                  value="courier"
                  checked={shippingType === 'courier'}
                  onChange={() => handleShippingChange('courier')}
                />
                <span className="dialogbuy-shipping-text">
                  Курьер ({info.corPrice}₽)
                </span>
              </label>
              <label className="dialogbuy-shipping-label">
                <input
                  type="radio"
                  name="shipping"
                  value="russianpost"
                  checked={shippingType === 'russianpost'}
                  onChange={() => handleShippingChange('russianpost')}
                />
                <span className="dialogbuy-shipping-text">
                  Почта России ({info.ruPrice}₽)
                </span>
              </label>
            </div>
          </div>

          {/* Сумма заказа (товары + доставка) */}
          <div className="dialogbuy-field">
            <label>Сумма заказа (товары + доставка):</label>
            <div className="dialogbuy-sum">
              {totalWithDelivery.toLocaleString()} ₽
            </div>
            <small style={{ color: '#888' }}>
              (Товары: {totalPrice.toLocaleString()} ₽, доставка: {shippingPrice.toLocaleString()} ₽)
            </small>
          </div>

          {/* Список товаров */}
          <div className="dialogbuy-field">
            <label>Товары:</label>
            <div className="dialogbuy-items">
              {cartItems.map((item) => (
                <div key={item.id} className="dialogbuy-item">
                  <span>{item.title}</span>
                  <span>
                    {item.price.toLocaleString()} ₽ x {item.quantity}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Кнопки */}
          <div className="dialogbuy-buttons">
            <button type="submit" className="dialogbuy-submit">
              Отправить
            </button>
            <button type="button" className="dialogbuy-cancel" onClick={handleClose}>
              Отмена
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default DialogBuy;
